import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '@fuse/services/auth/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjectService } from '@fuse/services/project.service';
import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'project',
    templateUrl: './project.component.html',
    styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;
    private _fuseConfig: FuseConfig;

    loggedIn = false;
    signedInAlready = false;
    showSignInButton = false;
    projectId: number;
    projectData: any;
    projectDemogs: any;
    isCompanyLogo = false;
    companyLogoUrl = '';
    bannerImgUrl = '';
    lang = 'sr';

    constructor(
        private _authService: AuthService,
        private _projectService: ProjectService,
        private route: ActivatedRoute,
        private _router: Router,
        private _matSnackBar: MatSnackBar,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        this._fuseConfig = fuseConfig;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '8');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    signInToProject(): void {
        if (this.loggedIn) {
            this._projectService.signInToProject()
                .then(response => {
                    this.signedInAlready = true;

                    // Show the success message
                    this._matSnackBar.open(this._translate.instant('You have successfully applied for a job.'), '', {
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 2000,
                        panelClass: ['snack-notification']
                    });
                },
                    err => {
                        // Show the error message
                        this._matSnackBar.open(err.error.message, '', {
                            verticalPosition: 'top',
                            horizontalPosition: 'right',
                            duration: 2000,
                            panelClass: ['snack-notification-error']
                        });
                    });
        } else {
            this._router.navigate(['/login']);
        }
    }

    getMemberProjects(): void {
        this._projectService.listUserProjects()
            .then(response => {
                if (response.data) {
                    this.checkIfAlreadySigned(response.data);
                }
            });
    }

    checkIfAlreadySigned(data): void {
        data.forEach(element => {
            if (element.id === this.projectId) {
                this.signedInAlready = true;
            }
        });
        this.showSignInButton = true;
    }

    updateUrl(evt): void {
        this.bannerImgUrl = this._fuseConfig.api.url + this.projectData.api_employ_logo;
        this.isCompanyLogo = true;
    }

    getCity(str): string {
        const cityData = str ? str.split(',') : [];
        let city = '';
        if (cityData.length > 0) {
            city = cityData[0].trim() + ', ' + cityData[cityData.length - 1].trim();
            city = city === ', ' ? '' : city;
        }
        return city;
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this.projectId = parseInt(this.route.snapshot.params.id, 10);

        if (!this._authService.isAuthenticated()) {
            this.loggedIn = false;
            this.showSignInButton = true;
        } else {
            this.loggedIn = true;
            this.getMemberProjects();
        }

        this._authService.userSetComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                response => {
                    this.loggedIn = true;
                    this.getMemberProjects();
                },
                err => console.log('error:', err));

        this._authService.logoutComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                this.loggedIn = false;
            });

        this._projectService.onProjectChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                this.bannerImgUrl = this._fuseConfig.api.url + response.api_project_banner;
                this.projectData = response;

                // Leave details page if data/title is empty on selected language
                if (this.projectData.title === '') {
                    this._router.navigate(['/ads']);
                }
            });

        this._projectService.onDemogsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                this.projectDemogs = response;
            });

        this._translate.onLangChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this._projectService.getProject();
                this.getTranslations();
            });
        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
